import React from "react";
import { Box } from "@mui/material";
import { loanManagementUrl } from "../../../config";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import InitiateSababishaForm from "./initiateSababisha";

const base_url = loanManagementUrl.uri;

const PendingDisbursementsTable = () => {
  const isApproved = { approved: 0 };

  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    add: {
      key: "ADD",
      button_name: "Initiate Sababisha",
      Show_Button: true,
      permission: "CreatePermission",
    },
    approveSababisha: {
      key: "APPROVESABABISHA",
      button_name: "Approve Sababisha",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: "param", // Specify the model name here
      inputObjectName: "sababishaFunction",
      flag: 1,
    },
    dataObject: {
      ignoreFields: ["CreateDate", "UpdateDate", "IsActive"],
      objectName: "sababishaViewByColumnValues",
      parameters: isApproved,
      inputObjectName: "sababishaView",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Pending Disbursements"
        subtitle="Sababisha"
        FormComponent={InitiateSababishaForm}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default PendingDisbursementsTable;
